import React from 'react'

const TermandConditions = () => {
  return (
    <div>
      <ol>
        <li>
          <h4><b>Introduction</b></h4>
          <p>
            Welcome to the 
            <b> International Journal of Interdisciplinary Studies and System Science (IJISSS)</b>. 
            By accessing or using our website, submitting a manuscript, or engaging with our content, 
            you agree to abide by these <b>Terms and Conditions</b>. Please read them carefully before 
            using our services.
          </p>
        </li>

        <br />

        <li>
          <h4><b>Definitions</b></h4>
          <ul>
            <li>
              <b>"Journal"</b> refers to the International Journal of Interdisciplinary Studies and System Science (IJISSS).
            </li>
            <li>
              <b>"User"</b> refers to any individual or institution accessing the journal’s website or submitting content.
            </li>
            <li>
              <b>"Author"</b> refers to individuals submitting manuscripts for publication.
            </li>
            <li>
              <b>"Reviewer"</b> refers to experts conducting peer reviews.
            </li>
            <li>
              <b>"Editorial Board"</b> refers to the journal’s managing team.
            </li>
          </ul>
        </li>

        <br />

        <li>
          <h4><b>Use of the Website</b></h4>
          <ul>
            <li>
              Users may access and download content for <b>personal, academic, or research purposes</b> only.
            </li>
            <li>Unauthorized modification, reproduction, or distribution of journal content is prohibited.</li>
            <li>
              The journal is not responsible for <b>third-party websites or links</b> found on its platform.
            </li>
          </ul>
        </li>

        <br />

        <li>
          <h4><b>Manuscript Submission and Publication</b></h4>
          <ul>
            <li>Authors must ensure <b>originality</b> and adhere to ethical research practices.</li>
            <li>
              Submissions undergo a <b>peer-review process</b>, and the <b>editorial decision is final</b>.
            </li>
            <li>
              The journal reserves the right to <b>accept, reject, or request revisions</b>.
            </li>
            <li>
              Once published, authors <b>retain copyright</b> but grant the journal a 
              non-exclusive license to distribute the work.
            </li>
          </ul>
        </li>

        <br />

        <li>
          <h4><b>Open Access Policy</b></h4>
          <ul>
            <li>
              All articles are published under a <b>Creative Commons Attribution License (CC BY 4.0)</b>.
            </li>
            <li>
              Users can freely <b>read, share, and cite</b> journal content with proper attribution.
            </li>
          </ul>
        </li>

        <br />

        <li>
          <h4><b>Disclaimer of Liability</b></h4>
          <ul>
            <li>
              The journal <b>does not guarantee</b> the accuracy or completeness of published content.
            </li>
            <li>
              The views expressed in articles are those of the <b>authors</b> and not the journal.
            </li>
            <li>
              The journal is not liable for any <b>direct or indirect damages</b> arising from website use.
            </li>
          </ul>
        </li>

        <br />

        <li>
          <h4><b>Changes to Terms and Conditions</b></h4>
          <ul>
            <li>The journal reserves the right to <b>update or modify</b> these terms at any time.</li>
            <li>
              Continued use of the website implies <b>acceptance of any updates</b>.
            </li>
          </ul>
        </li>
      </ol>

      <p>For inquiries, contact us at <b>[journal email]</b>.</p>
    </div>
  )
}

export default TermandConditions
